import * as S from './styles';
import { useDecimalInput } from '../../../Services/decimalInput';

interface IProps {
  state?: any;
  setState?: any;
  autoComplete?: "on" | "off";
  type: "string" | "number" | "date" | "text" | "email" | "button";
  inputMode?: "decimal" | "numeric" | "text";
  placeholder?: string;
  maxLength?: number;
  label?: string;
  step?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  isInvalid?: boolean;
  size?: "sm" | "lg";
  onBlur?: (e: any) => void;
  onChenge?: (e: any) => void;  // Corrigir aqui
  as?: any;
  rows?: number;
  minWidth?: string | undefined;
  isButton?: boolean;
  onClick?: any;
}

export function InputDefault({
                               state,
                               setState,
                               label,
                               type,
                               inputMode,
                               autoComplete,
                               placeholder,
                               maxLength,
                               step,
                               min,
                               max,
                               disabled,
                               isInvalid,
                               size,
                               onBlur,
                               onChenge,  // Corrigir aqui
                               as,
                               rows,
                               minWidth,
                               isButton,
                               onClick
                             }: IProps) {
  const isDecimal = type === 'number';
  const onChange = setState ? (e: any) => setState(e.target.value) : onChenge;
  const decimal = useDecimalInput(state, onChange, { enabled: isDecimal, min });

  return (
    <div>
      <label>
        <div className="label">{label}</div>
        <S.Input minWidth={minWidth} isButton={isButton}>
          <S.FormInput
            as={as}
            type={isDecimal ? decimal.type : type}
            inputMode={isDecimal ? decimal.inputMode : inputMode}
            autoComplete={autoComplete}
            value={isDecimal ? decimal.value : state}
            placeholder={placeholder}
            maxLength={maxLength}
            onChange={isDecimal ? decimal.onChange : onChange}
            step={step}
            min={min}
            max={max}
            disabled={disabled}
            isInvalid={isInvalid}
            data-invalid={isInvalid ? 'true' : undefined}
            aria-invalid={isInvalid ? 'true' : undefined}
            onBlur={onBlur}
            rows={rows}
            onClick={onClick}
          />
        </S.Input>
      </label>
    </div>
  );
}
